import { Button, styled } from '@mui/material';
import { grayFilter } from 'app/components/ThemeProvider/colors';
import { getTheme } from 'app/components/ThemeProvider/theme';

const theme = getTheme();

export const StyledFilterButton = styled(Button)(({ isActive }: { isActive: boolean }) => ({
  display: 'flex',
  gap: '8px',
  p: '6px 16px',
  background: isActive ? grayFilter : 'transparent',
  boxShadow: isActive ? '2px 2px 32px rgba(0, 0, 0, 0.06)' : 'none',

  [theme.breakpoints.down('sm')]: {
    p: '8px !important',
  },
}));
